import { Customer, Group } from "@/types/profile";
import { getAllCustomers } from "./customerLookup";

/**
 * Returns the live list of tenants/customers from the API cache.
 * Backed by `GET /api/v1/tenants` via `customerLookup`.
 */
export function getCustomers(): Customer[] {
  return getAllCustomers();
}

/**
 * Groups are not yet exposed by the production API. Returns an
 * empty list until a real `/api/v1/groups` (or equivalent)
 * endpoint exists.
 */
export const getGroupsByCustomerId = (_customerId: string): Group[] => {
  return [];
};
